import LoyaltyCard from '../LoyaltyCard/LoyaltyCard.vue';
import StatusPointsCard from './../StatusPointsCard/StatusPointsCard.vue';

export default {
  name: 'Menu',
  components: {
    LoyaltyCard,
    StatusPointsCard
  },
  data () {
    return {
      actionCallbacksKeys: {
        'signin': 'connectAction',
        'logout': 'disconnectAction',
        'account': 'myAccount',
        'bookingsConnected': 'myBookingConnected',
        'bookingsDisconnected': 'myBookingDisconnected',
        'discover': 'discoverProgramAction',
        'help': 'helpAndSupportAction',
        'earnpoints': 'earnPointsAction',
        'usepoints': 'usePointsAction',
        'reward': 'rewardsAction',
        'status': 'statusAction',
        'join': 'createAccountAction',
      }
    };
  },
  props: {
    statusInfo: {
      type: [Object, String],
      required: false,
      default: null
    },
    isConnected: {
      type: [Boolean, String],
      default: false
    },
    isMember: {
      type: Boolean,
      required: false,
    },
    itemList: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: false
    },
    actionCallbacks: {
      type: Object,
      default: null
    },
    trackingEnLabel: {
      type: Object,
      default: null
    },
    loginLabel: {
      type: String,
      default: '',
    },
    closeA11yLabel: {
      type: String,
      default: '',
    },
    lang: {
      type: String,
      default: 'en',
    },
  },
  mounted() {
    this.setMenuHeight();
    window.addEventListener('resize', this.setMenuHeight);
    const { closeBtn } = this.$refs;
    closeBtn.focus();
  },
  destroyed() {
    window.removeEventListener('resize', this.setMenuHeight);
    this.$emit('navBtnFocus');
  },
  computed: {
    pageHasAllSafeBanner() {
      // to improve
      let bodyClass = document.body.className;
      if (bodyClass.includes('has-covid')) {
        return true;
      }
    },
    joinItem() {
      // get the join button data to passe it on the loyalty card based on new design !!
      return this.itemList.find(item => item.key === 'join');
    },
    containsStatusInfo() {
      return this.isConnected && this.isMember && this.statusInfo && (this.statusInfo.points != null) && this.statusInfo.statut ? true : false;
    },
    containsUserName() {
      return this.isConnected && this.statusInfo && (this.statusInfo.username != null) ? true : false;
    },
    itemListLinks() {
      return this.itemList.filter(item => (item.link && !item.type && !item.type !== 'heading') || (item.key === 'logout'));
    },
    itemLoyaltyCard() {
      return this.itemList.find(item => item.key === 'loyaltyCard');
    },
    StatusPointWording() {
      return this.itemList.find(item => item.key === 'statuspoints') ? this.itemList.find(item => item.key === 'statuspoints').wordings : null;
    },
    itemListCta() {
      // we moved the join button on the loyalty card based on new design !!
      return this.itemList.filter(item => item.type && item.type === 'cta' && item.key !== 'join');
    }
  },
  methods: {
    accessibilityHandler(e) {
      switch (e.key) {
        case 'Tab': {
          const focusableElms = this.getFocusableElements();
          const activeElt = document.activeElement;
          let element;
          if (e.shiftKey && activeElt === focusableElms[0]) {
            element = focusableElms[focusableElms.length - 1];
          }
          if (!e.shiftKey && activeElt === focusableElms[focusableElms.length - 1]) {
            element = focusableElms[0];
          }
          if (element) {
            e.preventDefault();
            element.focus();
          }
          break;
        }
      }
    },
    getFocusableElements() {
      const { loginNavMenu } = this.$refs;
      const focusableElements = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';
      const elements = loginNavMenu.querySelectorAll(focusableElements);
      return [...elements].filter(
        element => element.offsetParent !== null
      );
    },
    setMenuHeight() {
      // to improve
      let menu = document.getElementById('login-nav-menu-wrapper');
      const headerHeight = 60;
      const windowHeight = window.innerHeight;
      let menuHeight = (windowHeight - headerHeight - 12);
      if (this.pageHasAllSafeBanner) {
        menuHeight -= 50;
      }
      let menuHeightString = menuHeight.toString() + 'px';
      menu.style.maxHeight = menuHeightString;
    },
    getItemPosition(item){
      const loginWordingData = this.itemList;

      // Filter items based on conditions (type, link)
      const dataEventEntries = loginWordingData.filter(itemList =>
        itemList.type === 'cta' || itemList.link !== null
      );
      dataEventEntries.unshift({key: 'menu', position: '0'})
      // Find position based on the key
      let position;
      if (item.key === 'logout') {
        position = dataEventEntries.length;
      } else {
        const foundItem = dataEventEntries.find(element => element.key === item.key);
        position = foundItem ? dataEventEntries.indexOf(foundItem) : -1;
      }
      return position;
    },
    executeItemActionAndRedirection(item) {
      // Item's key is emitted to the service for callback and tracking handling
      const itemTrackingLabel = typeof this.trackingEnLabel[item.key] !== 'undefined' ? this.trackingEnLabel[item.key].text : '';
      this.$emit('clickOnItem', {
        'label' : itemTrackingLabel  ? itemTrackingLabel.toLowerCase() :  '',
        'key' : item.key,
        'position' : this.getItemPosition(item)
      });
      this.$emit('loginNavClose', true);
      const fn = this.actionCallbacksKeys[item.key] || null;
      if (fn && this.actionCallbacks && typeof this.actionCallbacks[fn] === 'function') {
        this.actionCallbacks[fn]();
      } else {
        if (item.link && item.link.includes('https://')) {
          window.location.href = item.link;
        }
      }
    }
  }
};
